import { style, media } from "typestyle";
import { colors, queries } from "styles/styles";

export const text = style({
  color: colors.hooplaTextColor
});

export const normal = style({});

export const headline = style(
  {
    fontWeight: 900,
    fontSize: "24px",
      marginBottom: "10px"
  },
  media(queries.medium, {
    fontSize: "22px"
  })
);

export const subheading = style(
  {
    fontWeight: 900,
    fontSize: "24px",
    opacity: 0.47
  },
  media(queries.medium, {
    fontSize: "22px"
  })
);

export const subsubheading = style({
  fontWeight: 600,
  fontSize: "13px",
  lineHeight: 1.5,
  letterSpacing: "0.1em",
  textTransform: "uppercase"
});

export const position = {
  left: style({ textAlign: "left" }),
  center: style({ textAlign: "center" }),
  right: style({ textAlign: "right" })
};

export const color = {
  normal: style({ color: colors.hooplaTextColor120 }),
  grey: style({ color: colors.hooplaTextColor, opacity: 0.7 }),
  black: style({ color: colors.hooplaTextColor }),
  red: style({ color: colors.red_00 })
};
